import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'

export default [
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/chat/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/home',
    meta: {
      title: '客服中心'
    }
  },
  // 原有的客服页面
  // {
  //   component: Loadable({
  //     loader: () => import('@/pages/customerService/home/index'),
  //     loading: LoadingComponent
  //   }),
  //   path: '/courierView/customerService/home',
  //   //  @/pages/customerService/home/index',
  //   meta: {
  //     title: '客服中心'
  //   }
  // },
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/faqDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/faqDetail/:id',
    meta: {
      title: '常见问题'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/complainsRecords/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/complainsRecords',
    meta: {
      title: '投诉记录查询'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/complainsDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/complainsDetail/:id',
    meta: {
      title: '投诉详情'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/annex/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/annex/:ticketId'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/appealRecords/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/appealRecords',
    meta: {
      title: '申诉记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/appealDetail/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/appealDetail/:id',
    meta: {
      title: '申诉详情'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/punishList/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/punishList'
  },
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/appealReason/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/appealReason/:id',
    meta: {
      title: '填写申诉原因'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/customerService/processRecords/index'),
      loading: LoadingComponent
    }),
    path: '/courierView/customerService/processRecords',
    meta: {
      title: '处理进度'
    }
  }
]
